// removed by extract-text-webpack-plugin
module.exports = {"image-cropper":"image-cropper","cropper-preview":"cropper-preview"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/ImageCropper/Modal.scss
// module id = 39Pr
// module chunks = 0